import { SortOrder } from '../components/common/types';
import { DateTime } from 'luxon';

export const sortByDate = (a: string, b: string, order: SortOrder) => {
  const dateA = DateTime.fromISO(a);
  const dateB = DateTime.fromISO(b);
  return order === SortOrder.ASC ? dateA.diff(dateB).milliseconds : dateB.diff(dateA).milliseconds;
};
